import React from "react";
import {
  Modal,
  Container,
  Typography,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormHelperText,
  Button,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  modalRemoveContainer: {
    position: "absolute",
    width: 300,
    height: 400,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    margin: "auto",
  },
  modalRemoveDiv: {
    marginTop: theme.spacing(2),
  },
  modalButtonsRemove: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    marginTop: theme.spacing(3),
  },
  radioGroupDiv: {
    height: 250,
    width: 250,
    overflowY: "scroll",
    '&::-webkit-scrollbar': {
      display: "none"
    },
  },
}));

export default function RemoveModal({
  open,
  setOpen,
  handleSubmit,
  radioValue,
  setRadioValue,
  helperText,
  loading,
}) {
  const classes = useStyles();
  const events = useSelector((state) => state.calendar.calendarList);

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <Container className={classes.modalRemoveContainer}>
        {events.length === 0 && <Typography>No Events Found</Typography>}
        {events.length !== 0 && (
          <div className={classes.modalRemoveDiv}>
            <form onSubmit={handleSubmit}>
              <FormControl>
                <FormLabel component="legend">Event to delete:</FormLabel>
                <div className={classes.radioGroupDiv}>
                  <RadioGroup
                    value={radioValue}
                    onChange={(event) => setRadioValue(event.target.value)}
                  >
                    {events.map((item,index) => (
                      <FormControlLabel
                        value={item.id}
                        control={<Radio />}
                        label={item.title}
                        key={index}
                      />
                    ))}
                  </RadioGroup>
                </div>
                <FormHelperText>
                  {helperText}
                </FormHelperText>
                <div className={classes.modalButtonsRemove}>
                  <Button
                    variant="contained"
                    color="secondary"
                    type="submit"
                    style={{ marginRight: 10 }}
                    disabled={loading}
                  >
                    Remove
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => setOpen(false)}
                    disabled={loading}
                  >
                    Cancel
                  </Button>
                </div>
              </FormControl>
            </form>
          </div>
        )}
      </Container>
    </Modal>
  );
}
